import { Box, Grid, Typography } from "@material-ui/core";
import FilmIconForm from "./filmIconForm";

export default function FilmIconEditPage({ disabled, ...props }) {
  return (
    <>
      <Box width="100%">
        <Typography variant="h4" gutterBottom>
            Film &gt; Edit Film Icon
        </Typography>
      </Box>
      <Grid container xs={6}>
        <FilmIconForm
          description="Edit Icon"
          submitBtnTxt="Save Changes"
          upperBtnGroupSize="50%"
          history={props.history}
          disabled={disabled}
        />
      </Grid>
    </>
  );
}
